import React, { useState, useMemo, useEffect } from 'react';
import { useLocation } from '@reach/router';
import Container from 'components/UI/Container';
import Tabs from 'components/UI/Tabs';
import Layout from './components/Layout';
import { createTabID, createPanelID } from 'utils/tabs';
import { withErrorBoundary } from 'components/ErrorBoundary';

import * as styles from './ProjectConcept.module.scss';

function ProjectConcept({ projectData: data, active, setActive }) {
  const tabsAriaLabel = 'Project Case Tabs';
  const location = useLocation();
  const [opacity, setOpacity] = useState({
    '--opacity': 1,
  });

  useEffect(() => {
    if (location.state?.prevPath && location.state?.prevPath.includes('design-studio')) {
      setActive(
        data
          .find(
            ({ tabLabel }) =>
              tabLabel.toLowerCase() === 'visual concept' ||
              tabLabel.toLowerCase() === 'design-konzept',
          )
          ?.tabLabel.toLowerCase() ?? data[0].tabLabel.toLowerCase(),
      );
    }
    if (location.state?.prevPath && location.state?.prevPath.includes('/industries/healthcare')) {
      setActive(
        data
          .find(
            ({ tabLabel }) =>
              tabLabel.toLowerCase() === 'healthcare' ||
              tabLabel.toLowerCase() === 'gesundheitswesen',
          )
          ?.tabLabel.toLowerCase() ?? data[0].tabLabel.toLowerCase(),
      );
    }
    if (location.state?.prevPath && location.state?.prevPath.includes('business-analysts')) {
      setActive(
        data
          .find(
            ({ tabLabel }) =>
              tabLabel.toLowerCase() === 'business analysis' ||
              tabLabel.toLowerCase() === 'business analyse',
          )
          ?.tabLabel.toLowerCase() ?? data[0].tabLabel.toLowerCase(),
      );
    }
    if (
      location.state?.prevPath &&
      location.state?.prevPath.includes('/services/mobile-development')
    ) {
      setActive(
        data
          .find(
            ({ tabLabel }) =>
              tabLabel.toLowerCase() === 'mobile development' ||
              tabLabel.toLowerCase() === 'mobile entwicklung',
          )
          ?.tabLabel.toLowerCase() ?? data[0].tabLabel.toLowerCase(),
      );
    }
  }, [data]);

  const tabs = useMemo(() => {
    return data?.map(({ tabLabel }) => ({ id: tabLabel.toLowerCase(), tabLabel }));
  }, [data]);

  return (
    <Container className={styles.container} padding="Without" theme="fullWidth">
      <div className={styles.visualConcept}>
        {tabs && (
          <div className={styles.block}>
            <Tabs
              filters={tabs}
              active={active}
              setActive={setActive}
              setStyles={setOpacity}
              tabsAriaLabel={tabsAriaLabel}
            />
          </div>
        )}
        {data.map((item, i) => (
          <div
            key={item.tabLabel}
            id={createPanelID(tabsAriaLabel, i)}
            className={styles.sections}
            style={opacity}
            role="tabpanel"
            tabIndex={0}
            aria-labelledby={createTabID(tabsAriaLabel, i)}
            hidden={active !== item.tabLabel.toLowerCase()}
          >
            <Layout {...item} />
          </div>
        ))}
      </div>
    </Container>
  );
}

ProjectConcept.displayName = 'ProjectConcept';

export default withErrorBoundary(ProjectConcept);
